import {
  FETCH_SOLAR_ENERGY_GENERATED_REQUEST,
  FETCH_SOLAR_ENERGY_GENERATED_SUCCESS,
  FETCH_SOLAR_ENERGY_GENERATED_FAILURE,
} from './types';

const initialState = {
  loading: false,
  data: null,
  error: null,
  siteId: null,
};

const getDisplayedValues = (payload) =>
  Array.isArray(payload)
    ? payload.map((metric) => ({
        category: metric?.category || metric?.name || metric?.tagName,
        total: metric?.total,
        values: Array.isArray(metric?.data)
          ? metric.data.map((row) => ({
              total: row?.total,
              value: row?.value,
            }))
          : [],
      }))
    : payload;

const areDisplayedValuesEqual = (currentPayload, nextPayload) => {
  if (currentPayload === nextPayload) return true;

  try {
    return (
      JSON.stringify(getDisplayedValues(currentPayload)) ===
      JSON.stringify(getDisplayedValues(nextPayload))
    );
  } catch (error) {
    return false;
  }
};

const solarEnergyGeneratedReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_SOLAR_ENERGY_GENERATED_REQUEST: {
      const siteId = action.payload?.siteId;
      const hasCurrentData = state.data !== null && state.data !== undefined;
      return {
        ...state,
        loading: !(state.siteId === siteId && hasCurrentData),
        error: null,
        siteId,
      };
    }
    case FETCH_SOLAR_ENERGY_GENERATED_SUCCESS: {
      const nextData = action.payload?.data;
      return {
        ...state,
        loading: false,
        data: areDisplayedValuesEqual(state.data, nextData) ? state.data : nextData,
        error: null,
        siteId: action.payload?.siteId,
      };
    }
    case FETCH_SOLAR_ENERGY_GENERATED_FAILURE:
      return {
        ...state,
        loading: false,
        data: state.siteId === action.payload?.siteId ? state.data : null,
        error: action.payload?.error || action.payload,
        siteId: action.payload?.siteId,
      };
    default:
      return state;
  }
};

export default solarEnergyGeneratedReducer;
